/**
 * Component to redirect users to the sign up flow
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

const propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
};

function OrgRedirect({ location }) {
  return (
    <Redirect
      to={{
        pathname: '/sign-up/org',
        state: { from: location.pathname },
      }}
    />
  );
}

OrgRedirect.propTypes = propTypes;

export default OrgRedirect;
